import React from 'react'
import './spinner.css'

const Spinner = () => {
  return (
    <div classname='spinner'></div>
  )
}

export default Spinner